export default __webpack_public_path__ + "static/media/business-26b.eb9297fb.jpg";